export function switchTheme() {
  return {
    type: 'SWITCH_THEME',
  }
}
